import { PreparedWorkload } from 'features/workload-optimization';

import { useHideHpa } from './permissions/useHideHpa';

export const useWorkloadHasLegacyHpaSettings = ({
  workload,
}: {
  workload?: PreparedWorkload;
}) => {
  const { hideHpa } = useHideHpa();

  return {
    workloadHasLegacyHpaSettings:
      !hideHpa && !workload?.workloadConfigV2.hpaConfig.useNative,
  };
};
